module.exports = __webpack_public_path__ + "img/11087927_L.49c5a8ca.png";